import { subtitleLandingMedium } from "assets/jss/material-kit-pro-react";
import { subtitleLandingLight } from "assets/jss/material-kit-pro-react";
import { primaryColorLanding } from "assets/jss/material-kit-pro-react";
import { PrimaryFontColorLanding } from "assets/jss/material-kit-pro-react";

const style = (theme) => ({
  container: {
    paddingRight: "180px",
    paddingLeft: "180px",
    zIndex: "2",
    position: "relative",
    backgroundColor: primaryColorLanding,
    "& h1, & h2, & h4, & h6": {
      color: PrimaryFontColorLanding,
    },
    [theme.breakpoints.down("sm")]: {
      paddingRight: "24px",
      paddingLeft: "24px",
    },
    [theme.breakpoints.down("xs")]: {
      paddingRight: "8px",
      paddingLeft: "8px",
    },
  },
  mainGridContainer: {
    width: "100%",
    maxWidth: "1040px",
    [theme.breakpoints.down("sm")]: {
      paddingRight: "24px",
      paddingLeft: "24px",
    },
    [theme.breakpoints.down("xs")]: {
      paddingRight: "8px",
      paddingLeft: "8px",
    },
  },
  title: {
    ...subtitleLandingMedium,
    textTransform: "none",
    marginBottom: theme.spacing(4),
    textAlign: "center",
    [theme.breakpoints.up("md")]: {
      textAlign: "left",
    },
  },
  customTabButton: {
    fontWeight: "bold",
    fontSize: "0.9rem",
    textTransform: "uppercase",
    [theme.breakpoints.down("sm")]: {
      padding: "12px",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "8px",
      fontSize: "0.75rem",
    },
  },
  activeTab: {
    backgroundColor: "#00bcd4",
    color: "#fff",
  },
  tabContent: {
    ...subtitleLandingLight,
    marginTop: theme.spacing(2),
    textAlign: "center",
    [theme.breakpoints.up("md")]: {
      textAlign: "left",
    },
  },
  tabContentText: {
    ...subtitleLandingLight,
  },
});

export default style;
